export default class Warning{

	static show(options){

		var defaults = {
			state:"info",
		 	backgroundColor:'#fff',
		 	color:"#000",
		 	text:"是否执行该操作？",
		 	cornerRadius:"10",
		 	fontSize:'14px',
		 	title:'',
		 	interacdestroy:false,
		 	confirm:{
		 		isShow:true,
				event:'',
				text:'' 
		 	},
		 	cancel:{
		 		isShow:false,
		 		event:''
			},
			mutiLine:false 

		}

		// var stateColor={
		// 	info:'alert-info',
		// 	warn:'alert-warning',
		// 	error:'alert-danger',
		// 	success:'alert-success'
		// }

		// var stateIcon={
		// 	info:'fa-info',
		// 	warn:'fa-warning',
		// 	error:'fa-ban',
		// 	success:'fa-check'
		// }

		// var stateMsg={
		// 	info:'提示',
		// 	warn:'警告',
		// 	error:'错误',
		// 	success:'成功'
		// }

		// var btnState={
		// 	info:'btn-info',
		// 	warn:'btn-warning',
		// 	error:'btn-danger',
		// 	success:'btn-success'
		// }

		// var fontColor={
		// 	info:'#00c0ef',
		// 	warn:'#f39c12',
		// 	error:'#dd4b39',
		// 	success:'#008d4c'
		// }

		var titleMsg={
			info:'INFO',
			warn:'WARN',
			error:'ERROR',
			success:'SUCCESS'
		}

		var btnStyle={
			info:{
				color:'#fff',
				backgroundColor:'#f39c12',
				width:'80px',
				height:'28px',
				padding:'3px',
				fontSize:'14px',
				iconMainClass:"fa fa-info-circle",
				iconClass:'text-blue',
				border:'1px solid #f39c12'
			},
			warn:{
				color:'#fff',
				backgroundColor:'#f39c12',
				width:'80px',
				height:'28px',
				padding:'3px',
				fontSize:'14px',
				iconMainClass:"fa fa-exclamation-circle",
				iconClass:'text-yellow',
				border:'1px solid #f39c12',
			},
			error:{
				color:'#fff',
				backgroundColor:'#f39c12',
				width:'80px',
				height:'28px',
				padding:'3px',
				fontSize:'14px',
				iconMainClass:"fa fa-times-circle",
				iconClass:'text-red',
				border:'1px solid #f39c12'
			},
			success:{
				color:'#fff',
				backgroundColor:'#f39c12',
				width:'80px',
				height:'28px',
				padding:'3px',
				fontSize:'14px',
				iconMainClass:"fa fa-check-circle",
				iconClass:'text-green',
				border:'1px solid #f39c12'
			}
		}

		var btnContent={
			info:'确认',
			warn:'确认',
			error:'关闭',
			success:'关闭'
		}

		$.extend(true, defaults, options);

		let $2 = $;
		if(!window.isSelfFrameRoot)
		{
			$2 = parent.$;
			
		}
  		
  		
		var closeBtn=$2('<div class="modal-close"></div>');
		  //.on('click',function(){alert(1111111);$(alertDiv).remove();});
  		
  		var titleH=$2('<h5></h5>').addClass('modal-title').html(defaults.title?defaults.title:titleMsg[defaults.state]);//判断显示内容
		var headerDiv=$2('<div></div>').addClass('modal-header').append(closeBtn).append(titleH);

		var bodyIcon = $2('<i class="'+btnStyle[defaults.state].iconMainClass +" "+ btnStyle[defaults.state].iconClass +'" aria-hidden="true" style="font-size: 33px;margin-right: 9px;"></i>');
		var textStyle = {'font-size':defaults.fontSize,'font-family':'STSongti-SC-Regular',color:'#000000','margin-bottom':'0px','margin-top':'6px'};
		if(!defaults.mutiLine)
		{
			textStyle['white-space']='pre';
		}
		var bodyP=$2('<p>'+defaults.text+'</p>').css(textStyle);
		var _maxHeight = '300px';
		if(defaults.mutiLine == true)
		{
			_maxHeight = '';
		}
  		var bodyDiv=$2('<div></div>').addClass('modal-body').append(bodyIcon).append(bodyP).css({'overflow':'auto','max-height':_maxHeight,'display':'flex',paddingTop:'30px',paddingBottom:'30px'});
  		
  		var cancelBtn=$2('<button></button>').attr('type','button').addClass('btn btn-default').html('取消').css({'width':'80px',height:'28px',padding:'3px','font-size':'14px'});
  		var confirmBtn=$2('<button></button>').attr('type','button').addClass('btn').css(btnStyle[defaults.state]).html(defaults.confirm.text?defaults.confirm.text:btnContent[defaults.state]).css('margin-right','10px');
  		//判断是否显示取消确定按钮
  		var footerDiv=$2('<div></div>').addClass('modal-footer').css({'border-top':'none',padding:'10px',borderTop:'1px solid rgba(0,0,0,0.10)'});
		  
		if(defaults.cancel.isShow)
		  footerDiv.append(cancelBtn);  
		
  		if(defaults.confirm.isShow)
			footerDiv.append(confirmBtn);

  		
		confirmBtn.on('click',function() {
			if(typeof(defaults.confirm.event) == "function")
			{
				defaults.confirm.event();
			}
			window.testWarnShowedToRemove = true;
			window.testWarnShowing = false;
			if(options.rowrowChangeAutoSaveWarn){
				window.rowrowChangeAutoSaveWarn = false;
			}
			$2(alertDiv).remove();
			
		
			//if(typeof(window.restoreLastFocus) == "function")
			//		window.restoreLastFocus();
		}).one('keydown',function(e){

			if(e.keyCode == 17)
			{
				if(typeof(defaults.confirm.event) == "function")
				{
					defaults.confirm.event();
				}
				window.testWarnShowedToRemove = true;
				window.testWarnShowing = false;
				$2(alertDiv).remove();
			}

		});


		if(defaults.cancel.event==''){
			cancelBtn.one('click',function() {
				window.testWarnShowedToRemove = true;
				window.testWarnShowing = false;
				$2(alertDiv).remove();
				//if(typeof(window.restoreLastFocus) == "function")
				//	window.restoreLastFocus();
			})
		}
  		var contentDiv=$('<div></div>').addClass('modal-content').append(headerDiv).append(bodyDiv).append(footerDiv);

  		var dialogDiv=$('<div></div>').append(contentDiv).css({'position':'relative',minWidth:'508px',background:'#FFFFFF',border:'0 solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'});

  		var alertDiv=$('<div></div>').addClass('modal gongqi-warn').append(dialogDiv).css({'display':'flex','align-items':'center','justify-content':'center','z-index':'2001'});
		alertDiv.one('keydown',function(e)
		{
			if(e.keyCode == 27)
			{
				e.preventDefault();
				e.stopImmediatePropagation();
				window.testWarnShowing = false;
				alertDiv.remove();
				if(typeof(window.restoreLastFocus) == "function")
					window.restoreLastFocus();
			}
		});
		
		$2("body").append(alertDiv);
		

		$2(closeBtn).on('click',function()
			{
				if(options.rowrowChangeAutoSaveWarn){
					window.rowrowChangeAutoSaveWarn = false;
				}
				$2(alertDiv).remove();
				
			}
		);

		confirmBtn.focus();
		window.testWarnShowing = true;
	}
}


// WEBPACK FOOTER //
// ./src/utils/Warn.js